<template>
    <div class="price-data">

        <div v-if="priceData.shippingCosts" class="price-row shipping-costs">
            <span class="section-header">{{ $t('Checkout.priceData.shippingCosts') }}</span>
            <span class="shipping-costs-value">{{ priceData.shippingCosts | formatPriceFilter }}</span>
        </div>

        <div v-if="priceData.voucherValue" class="price-row voucher-value">
            <span class="section-header">{{ $t('Checkout.priceData.voucherValue') }}</span>
            <span>{{ priceData.voucherValue | formatPriceFilter }}</span>
        </div>

        <div v-if="showStrikeoutDiscount" class="price-row list-price">
            <span class="ml-auto list-price-value">
                <em
                    ><s>{{ priceData.totalListPrice | formatPriceFilter }}</s></em
                >
            </span>
        </div>

        <div class="price-row amount-to-pay">
            <span class="section-header">{{ $t('Checkout.priceData.total') }}</span>
            <span class="price-value">{{ priceData.amountToPay | formatPriceFilter }}</span>
        </div>

        <div v-if="priceData.totalSaving" class="price-row total-saving">
            <span class="ml-auto">{{
                $t('Checkout.priceData.totalSaving', {
                    saving: $options.filters.formatPriceFilter(priceData.totalSaving)
                })
            }}</span>
        </div>

        <slot name="after"> </slot>
    </div>
</template>

<script>
import formatPriceFilter from '@/filters/formatPrice';

export default {
    name: 'PriceData',
    filters: { formatPriceFilter },
    props: {
        priceData: Object
    },
    computed: {
        //or named as list price
        showStrikeoutDiscount() {
			try {
				return (
					Number.parseInt(this.priceData.totalListPrice) !== 0 &&
					this.priceData.totalListPrice > this.priceData.totalProductPrice
				);
			} catch (e) {
				console.log(e);
			}
        }
    }
};
</script>

<style scoped lang="scss">
.price-data {
    margin-bottom: 15px; //CLS prevention

    div.price-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: baseline;

        &.list-price {
            font-size: 20px;
        }

        &.amount-to-pay {
            .price-value {
                font-size: 30px;
                font-weight: bold;
            }
        }

        &.total-saving {
				color: var(--primary-accessible, var(--primary));
        }
    }
}
</style>
